
import  * as TgclubGameComponent from './game';
import TgclubApi from './tgclubApi';
import tool from './tool';

export  {
  TgclubApi,
  TgclubGameComponent,
  tool,
};


export default {
  TgclubApi,
  TgclubGameComponent,
  tool,
};
